import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://fhspagydirwvkpaknzmp.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZoc3BhZ3lkaXJ3dmtwYWtuem1wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA2Mzg3NjAsImV4cCI6MjA3NjIxNDc2MH0.IIZkdcdvloA0TXL0c5tFkfBMHXVW5r1qyyZF8BH4sIs';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database setup SQL (run this in your Supabase SQL editor)
export const DATABASE_SETUP_SQL = `
-- Creature Superpowers Survey Responses table
-- Privacy-conscious: No personal identifying information collected
CREATE TABLE IF NOT EXISTS creature_survey_responses (
  id UUID PRIMARY KEY DEFAULT gen_random_uuid(),

  -- Session tracking (anonymous)
  session_id VARCHAR(255) NOT NULL, -- Anonymous session identifier

  -- Game completion data
  creature_type VARCHAR(50) NOT NULL, -- dragon, unicorn, mermaid, turtle, spider, elephant
  creature_name VARCHAR(255), -- Optional: child's creature name
  selected_powers JSONB, -- Array of selected superpower IDs

  -- Survey responses (emoji-based)
  feeling_emoji VARCHAR(10) NOT NULL, -- How do you feel? (😊, 😍, 🤔, 😌, 🤩)
  feeling_label VARCHAR(50) NOT NULL, -- Happy, Excited, Thoughtful, Calm, Amazed
  favorite_part_emoji VARCHAR(10) NOT NULL, -- Favorite part? (🎤, 🐉, ⚡, ✏️, ✨)
  favorite_part_label VARCHAR(50) NOT NULL, -- Voice Drawing, Choosing Creature, Superpowers, Drawing, Everything

  -- Metadata
  language VARCHAR(5) DEFAULT 'en', -- en or es
  game_duration_seconds INTEGER, -- Time spent in game
  completed_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),

  -- Analytics (optional)
  user_agent TEXT, -- Browser/device info for accessibility insights
  screen_size VARCHAR(50) -- Device screen size category
);

-- Indexes for analytics queries
CREATE INDEX IF NOT EXISTS idx_survey_creature_type ON creature_survey_responses(creature_type);
CREATE INDEX IF NOT EXISTS idx_survey_feeling ON creature_survey_responses(feeling_emoji);
CREATE INDEX IF NOT EXISTS idx_survey_favorite ON creature_survey_responses(favorite_part_emoji);
CREATE INDEX IF NOT EXISTS idx_survey_completed_at ON creature_survey_responses(completed_at);
CREATE INDEX IF NOT EXISTS idx_survey_language ON creature_survey_responses(language);

-- Enable Row Level Security (RLS)
ALTER TABLE creature_survey_responses ENABLE ROW LEVEL SECURITY;

-- Policy: Anyone can insert survey responses (anonymous submissions)
CREATE POLICY "Allow anonymous survey submissions" ON creature_survey_responses
  FOR INSERT WITH CHECK (true);

-- Policy: Only authenticated users can read survey data (for analytics dashboard)
CREATE POLICY "Only authenticated users can view surveys" ON creature_survey_responses
  FOR SELECT USING (auth.role() = 'authenticated');
`;

// Helper function to generate anonymous session ID
export function generateSessionId(): string {
  return `session_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
}

// Get or create session ID from localStorage
export function getSessionId(): string {
  if (typeof window === 'undefined') return generateSessionId();

  const stored = localStorage.getItem('creature_session_id');
  if (stored) return stored;

  const newId = generateSessionId();
  localStorage.setItem('creature_session_id', newId);
  return newId;
}
